import React, { useState } from "react";
import { appleEmojiUrls } from "../utils/emojiUnified";

const AppleEmoji = ({ emoji, size = 20, className = "" }: { emoji: string; size?: number; className?: string }) => {
    const { primary, fallback } = appleEmojiUrls(emoji);
    const [src, setSrc] = useState(primary);
    return (
        <img
            src={src}
            alt={emoji}
            draggable={false}
            className={`inline-block align-middle ${className}`}
            style={{ width: size, height: size }}
            onError={() => { if (src !== fallback) setSrc(fallback); }}
        />
    );
};
export default AppleEmoji;